import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../States/AppContext";

// styles
import {
  AlarmBoxContainer,
  AlarmBoxLeft,
  AlarmBoxRight,
  NoPiicLeft,
  NoPiicRight,
} from "./AlarmBox.elements";

const AlarmBox = () => {
  const { state, setState } = useContext(AppContext);

  const [boxActive, setBoxActive] = useState(true);

  useEffect(() => {
    if (boxActive === true) {
      const timeoutId = setTimeout(() => {
        setBoxActive((prevState) => !prevState);
      }, 1000);

      return () => clearTimeout(timeoutId);
    } else if (boxActive === false) {
      const timeoutId = setTimeout(() => {
        setBoxActive((prevState) => !prevState);
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [boxActive]);

  return (
    <>
      <AlarmBoxContainer>
        {state.xTachyAlarmAlert && (
          <>
            <AlarmBoxLeft active={boxActive}></AlarmBoxLeft>
            <AlarmBoxRight active={boxActive}></AlarmBoxRight>
          </>
        )}

        {!state.piicConnected && (
          <>
            <NoPiicLeft active={boxActive}></NoPiicLeft>
            <NoPiicRight active={boxActive}></NoPiicRight>
          </>
        )}
      </AlarmBoxContainer>
    </>
  );
};

export default AlarmBox;
